import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { TableColumnComponent } from '../table-column/table-column.component';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-column-select',
    templateUrl: './column-select.component.html',
    styleUrls: ['./column-select.component.scss'],
    standalone: false,
})
export class ColumnSelectComponent extends TableColumnComponent implements OnInit {
    @Input() public tooltipSelect: string;
    @Input() optionsClassName: string = '';
    @Input() public options: any[] | Observable<any>;
    @Input() public getOptionText: (o: any) => string;
    @Input() public customOption: string | null = null;
    @Input() public hasSearchFilter: boolean = false;
    @Input() public resetSearch: boolean = false;
    @Input() public selectorId: string = '';
    @Input() public isCvrStatus: boolean = false;
    @Output() public SearchFilterChanged = new EventEmitter();
    public SearchFilter: string = '';
    @Optional() @Input() public asyncOptionValueProperty: string;
    @Optional() @Input() public nonAsyncOptionValueProperty: string;
    @Optional() @Input() public allowMultiple: boolean = false;
    private searchSub$ = new Subject<string>();

    public ngOnInit() {
        super.ngOnInit();
        this.searchSub$.pipe(debounceTime(400), distinctUntilChanged()).subscribe((filterValue: string) => {
            if (filterValue === '') {
                this.SearchFilter = '';
            }
            this.SearchFilterChanged.emit(filterValue);
        });
    }

    public getOptions(): Observable<any> {
        // @ts-ignore
        return this.optionsAreSync() ? of(this.options) : this.options;
    }

    public getOption(option: any): string {
        let optionValue = this.optionsAreSync() ? option : option[this.asyncOptionValueProperty];
        if (this.nonAsyncOptionValueProperty) {
            optionValue = option[this.nonAsyncOptionValueProperty];
        }
        return optionValue ?? '';
    }

    public onSearchChanged(searchItem: string) {
        this.searchSub$.next(searchItem);
    }

    public onValueChanged($event: any) {
        if (this.hasSearchFilter) {
            this.searchSub$.next('');
        }
    }

    public clearFilter($event: any) {
        this.Filter = '';
        $event.stopPropagation();
    }

    public onFilterChange() {}

    private optionsAreSync(): boolean {
        return Array.isArray(this.options);
    }
}
